export enum EnumPaymentScheduleMethod {
  INSTALLMENT = "INSTALLMENT",
  PAY_BY_SELF = "PAY_BY_SELF",
}
